export function waitThenThrow(ms = 0, message?: string): Promise<never> {
	return new Promise((_, reject) => {
		setTimeout(() => reject(new Error(message ?? `Timeout after ${ms}ms`)), ms);
	});
}

export class Deferred<T> {
	public promise: Promise<T>;
	public resolveInternal: (value: T) => void;
	private setTimeoutId: number | null = null;
	private timeout: number;
	public resolved = false;

	constructor(options?: { timeout?: number }) {
		this.promise = new Promise<T>(resolve => {
			this.resolve = resolve;
		});
		if (options?.timeout !== undefined) {
			this.timeout = options.timeout;
		}
	}
	resetTimeout() {
		if (this.setTimeoutId) {
			clearTimeout(this.setTimeoutId);
		}
		this.setTimeoutId = setTimeout(this.resolve, this.timeout);
	}
	resolve(value: T): void {
		this.resolved = true;
		this.resolveInternal(value);
	}
}

// based on and extended from Malte Ubl's `await-interaction-response` pattern
// adds a deterministic "after paint" guarantee via double rAF + timeout fallback
// source: https://vercel.com/blog/demystifying-inp-new-tools-and-actionable-insights#introducing-await-interaction-response
export function afterNextPaint(timeoutMs = 100): Promise<void> {
	return new Promise(resolve => {
		let resolved = false;

		const done = () => {
			if (!resolved) {
				resolved = true;
				resolve();
			}
		};

		// primary path: end after paint
		requestAnimationFrame(() => {
			requestAnimationFrame(done);
		});

		// fallback: never block forever
		setTimeout(done, timeoutMs);
	});
}
